<alert class="alert-position"></alert>
<div class="row m-0">
  <div class="col-12">
    <div class="topSec">
      <div>
        <img class="logo" src="../../assets/img/logo/logo-white.svg" alt="Logo">
        <div class="wl-txt">Welcome to the</div>
        <div class="wl-t-ybp">world of {{titleText}}</div>
      </div>
    </div>
    <div class="bottomSec">
      <div class="login-wrpr">
        <div class="login-ttl" style="margin-bottom: 21px !important;">{{mobileSecDisp && this.cardForm.value.cardType === 'Voucher Code' ? 'Voucher Code' : 'Login'}}</div>
        <form [formGroup]="cardForm" *ngIf="!mobileSecDisp">
          <mat-form-field class="form-group example-full-width" style="margin-bottom: 2.65rem !important;">
            <mat-label>Gift Type</mat-label>
            <mat-select name="cardType" formControlName="cardType">
              <mat-option [value]="item.value" *ngFor="let item of cardTypeList">{{item.display}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="text-center error-btn-wrpr">
            <div class="error" *ngIf="cardError">
              This field is required.
            </div>
            <button type="button" class="btn btn-primary my-4" (click)="selectCardType()">Next
              <img src="../../assets/img/right-arrow.png" class="next-icon">
            </button>
          </div>
        </form>

        <form [formGroup]="mobileForm" *ngIf="mobileSecDisp">

          <mat-form-field class="form-group example-full-width" *ngIf="this.cardForm.value.cardType!='Physical Card'">
            <mat-label>Enter Mobile No.</mat-label>
            <input matInput type="tel" numbersOnly class="form-control" placeholder="" name="mobile" formControlName="mobile" minLength="10" maxLength="10" autocomplete="off">
          </mat-form-field>
          <div class="error-wrpr" *ngIf="mobileForm.get('mobile').invalid && (mobileForm.get('mobile').dirty || mobileForm.get('mobile').touched || mobileForm.get('mobile').errors.pattern)">
            <mat-error *ngIf="mobileForm.get('mobile').errors.required || mobileForm.get('mobile').errors.minlength || mobileForm.get('mobile').errors.maxlength || mobileForm.get('mobile').errors.pattern">
              Please enter only 10 digit valid phone number</mat-error>
          </div>

          <mat-form-field class="form-group example-full-width mb-2" *ngIf="this.cardForm.value.cardType=='Physical Card'">
            <mat-label>Last 6 digits of card</mat-label>
            <input matInput type="text" numbersOnly class="form-control" placeholder="" name="cardLastSixDigits" formControlName="cardLastSixDigits" minLength="6" maxLength="6" autocomplete="off">
          </mat-form-field>
          <div class="error-wrpr" *ngIf="mobileForm.get('cardLastSixDigits').invalid && (mobileForm.get('cardLastSixDigits').dirty || mobileForm.get('cardLastSixDigits').touched || mobileForm.get('cardLastSixDigits').errors.pattern)">
            <mat-error *ngIf="mobileForm.get('cardLastSixDigits').errors.required || mobileForm.get('cardLastSixDigits').errors.minlength || mobileForm.get('cardLastSixDigits').errors.maxlength || mobileForm.get('cardLastSixDigits').errors.pattern">
              Please enter only 6 digits.
            </mat-error>
          </div>

          <mat-form-field class="form-group example-full-width mb-2" *ngIf="this.cardForm.value.cardType=='Physical Card'">
            <mat-label>Kit Number</mat-label>
            <input matInput type="text" numbersOnly class="form-control" placeholder="" name="kitNo" formControlName="kitNo" autocomplete="off">
            <span class="fa fa-question-circle kitSuggetion" (click)="infoModalClose()"></span>
          </mat-form-field>
          <div class="error-wrpr" *ngIf="mobileForm.get('kitNo').invalid && (mobileForm.get('kitNo').dirty || mobileForm.get('kitNo').touched || mobileForm.get('kitNo').errors.pattern)">
            <mat-error *ngIf="mobileForm.get('kitNo').errors.required || mobileForm.get('kitNo').errors.pattern">
              Please enter valid Kit Number.
            </mat-error>
          </div>

          <div id="myModal" class="img-modal info-modal" *ngIf="infoModalOpen">
            <span class="info-close" (click)="infoModalClose()">&times;</span>
            <img class="info-modal-content" id="img01" src="../../assets/img/kit-number2.jpg">
          </div>

          <mat-form-field class="form-group example-full-width mb-2" *ngIf="this.cardForm.value.cardType=='Physical Card'">
            <mat-label>Expiry (MM/YY)</mat-label>
            <input matInput type="text" class="form-control" placeholder="" name="expiryDate" formControlName="expiryDate" minLength="5" maxLength="5" autocomplete="off" (ngModelChange)="onYpexpDateChange($event)">
          </mat-form-field>
          <div class="error-wrpr" *ngIf="mobileForm.get('expiryDate').invalid && (mobileForm.get('expiryDate').dirty || mobileForm.get('expiryDate').touched || mobileForm.get('expiryDate').errors.pattern)">
            <mat-error *ngIf="mobileForm.get('expiryDate').errors.required || mobileForm.get('expiryDate').errors.minlength || mobileForm.get('expiryDate').errors.maxlength || mobileForm.get('expiryDate').errors.pattern">
              Please enter Expiry in MM/YY format.</mat-error>
          </div>

          <mat-form-field class="form-group example-full-width mb-0" *ngIf="this.cardForm.value.cardType=='Physical Card'">
            <mat-label>PIN</mat-label>
            <input matInput type="password" numbersOnly class="form-control pb-1" placeholder="" name="pinNo" formControlName="pinNo" minLength="4" maxLength="4" autocomplete="off">
          </mat-form-field>
          <div class="error-wrpr" *ngIf="mobileForm.get('pinNo').invalid && (mobileForm.get('pinNo').dirty || mobileForm.get('pinNo').touched || mobileForm.get('pinNo').errors.pattern)">
            <mat-error *ngIf="mobileForm.get('pinNo').errors.required || mobileForm.get('pinNo').errors.minlength || mobileForm.get('pinNo').errors.maxlength || mobileForm.get('pinNo').errors.pattern">
              Please enter 4 digit valid PIN</mat-error>
          </div>

          <div class="otp-sec-ht" *ngIf="enableCaptcha">
            <div class="row pb-0 mt-0 justify-content-center">
              <div class="captcha-img" [ngStyle]="{'background-image':'url(' + captchSrc + ')'}"></div>
              <img class="reload-captcha" alt="reload-captcha" src="../../assets/img/reload-captcha.png" (click)="loadCaptcha(false)">
            </div>
            <mat-form-field class="form-group example-full-width mb-0">
              <mat-label>Please enter the answer below</mat-label>
              <input matInput type="text" class="form-control" placeholder="" name="captcha" formControlName="captcha" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="row mb-0 maxAttempt" *ngIf="maxAttempt">
            <div class="col ml-0">
              <small class="text-danger resendText">{{maxAttempt}}</small>
            </div>
          </div>
          <div class="text-center ot-none">
            <button mat-stroked-button color="accent" class="my-4" [disabled]="mobileForm.invalid || isSaving" (click)="submit()" *ngIf="this.cardForm.value.cardType!='Physical Card'">Get OTP
              <span class="spinner-border loadingSplinner" *ngIf="isSaving" role="status">
                <span class="sr-only"></span>
              </span>
            </button>
            <button mat-stroked-button color="accent" class="my-4" [disabled]="mobileForm.invalid || isSaving" (click)="submit()" *ngIf="this.cardForm.value.cardType=='Physical Card'">Submit
              <span class="spinner-border loadingSplinner" *ngIf="isSaving" role="status">
                <span class="sr-only"></span>
              </span>
            </button>
          </div>
        </form>

        <div class="bottomSec" *ngIf="otpSecDisp">
          <div class="login-wrpr">
            <div class="login-ttl">{{this.cardForm.value.cardType !== 'Voucher Code' ? 'YES Bank' : ''}} {{this.cardForm.value.cardType}}</div>
            <div class="login-subtl">Please enter the OTP sent on your registered mobile number - {{mobileForm.get('mobile').value}}</div>
            <form [formGroup]="editForm">
              <div class="form-group row pb-0 mb-1 form-group-otp">
                <ng-otp-input class="col-12  mt-2 text-center" *ngIf="showOtpComponent" #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
                <div class="error-wrpr" *ngIf="editForm.get('otp').invalid && (editForm.get('otp').dirty || editForm.get('otp').touched)">
                  <small class="form-text text-danger" *ngIf="editForm.get('otp').errors.required">
                    This field is required.
                  </small>
                  <small class="form-text text-danger" *ngIf="editForm.get('otp').errors.maxlength">
                    This field cannot be longer than 6 characters.
                  </small>
                </div>
              </div>
              <div class="row mb-0">
                <div class="col ml-0 text-center">
                  <small class="text-danger resendText" *ngIf="counter">Resend OTP in {{counter}} Seconds</small>
                  <button mat-stroked-button color="accent" class="my-0 resend-btn" *ngIf="counter==0" (click)="resendOtp()" [disabled]="isResend">Resend OTP</button>
                </div>
              </div>
              <div class="otp-sec-ht" *ngIf="enableCaptcha">
                <div class="row pb-0 mt-0 justify-content-center">
                  <div class="captcha-img" [ngStyle]="{'background-image':'url(' + captchSrc + ')'}"></div>
                  <img class="reload-captcha" alt="reload-captcha" src="../../assets/img/reload-captcha.png" (click)="loadCaptcha(false)">
                </div>
                <mat-form-field class="form-group example-full-width mb-0">
                  <mat-label>Please enter the answer below</mat-label>
                  <input matInput type="text" class="form-control" placeholder="" name="captcha" formControlName="captcha" autocomplete="off">
                </mat-form-field>
              </div>
              <div class="row mb-0 maxAttempt">
                <div class="col ml-0">
                  <small class="text-danger resendText">{{maxAttempt}}</small>
                </div>
              </div>
              <div class="text-center ot-none">
                <button mat-stroked-button color="accent" class="my-4" (click)="submitOtp()" [disabled]="editForm.invalid || isOtpSaving" [ngClass]="{'bt-mt-14' : enableCaptcha}">Submit OTP
                  <span class="spinner-border loadingSplinner" *ngIf="isOtpSaving" role="status">
                    <span class="sr-only"></span>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="bottomSec" *ngIf="redeemVoucherSecDisp">
          <div class="login-wrpr">
            <div class="login-ttl">{{this.cardForm.value.cardType}}</div>
            <form [formGroup]="voucherForm">

              <mat-form-field class="form-group example-full-width mb-2" *ngIf="this.cardForm.value.cardType=='Voucher Code'">
                <mat-label>Enter 12 Digit Voucher Code</mat-label>
                <input matInput type="text" class="form-control" placeholder="" name="voucherCode" formControlName="voucherCode" minLength="14" maxLength="14" autocomplete="off" voucher-code>
                <img class="info-icon" src="/assets/img/questionmark.svg" (click)="openInfo('VOU')" />
              </mat-form-field>
              <div class="error-wrpr" *ngIf="voucherForm.get('voucherCode').invalid && (voucherForm.get('voucherCode').dirty || voucherForm.get('voucherCode').touched || voucherForm.get('voucherCode').errors.pattern)">
                <mat-error *ngIf="voucherForm.get('voucherCode').errors.required || voucherForm.get('voucherCode').errors.minlength || voucherForm.get('voucherCode').errors.maxlength || voucherForm.get('voucherCode').errors.pattern">
                  Please enter valid voucher code
                </mat-error>
              </div>

              <mat-form-field class="form-group example-full-width mb-2" style="margin-top: 20px;" *ngIf="this.cardForm.value.cardType=='Voucher Code'">
                <img class="info-icon" src="/assets/img/questionmark.svg" (click)="openInfo('BEN')" />
                <mat-label>Beneficiary Name</mat-label>
                <input matInput type="text" class="form-control" style="max-width: 92%;" placeholder="" name="beneficiaryName" formControlName="beneficiaryName" minLength="1" maxLength="50" autocomplete="off" (input)="onInput($event.target)">
              </mat-form-field>
              <div class="error-wrpr" *ngIf="voucherForm.get('beneficiaryName').invalid && (voucherForm.get('beneficiaryName').dirty || voucherForm.get('beneficiaryName').touched || voucherForm.get('beneficiaryName').errors.pattern)">
                <mat-error *ngIf="voucherForm.get('beneficiaryName').errors.required || voucherForm.get('beneficiaryName').errors.minlength || voucherForm.get('beneficiaryName').errors.maxlength || voucherForm.get('beneficiaryName').errors.pattern">
                  Please enter valid beneficiary name
                </mat-error>
              </div>

              <div class="form-group example-full-width custom-checkbox">
                <input type="checkbox" class="d-none" id="terms" name="tnc" formControlName="tnc">
                <label for="terms">I agree to the <span (click)="goToTermsPage()">Terms and Conditions.</span></label>
              </div>
              
              <div class="text-center ot-none">
                <button mat-stroked-button color="accent" class="my-4" (click)="redeemVoucher()" [disabled]="voucherForm.invalid || isVoucherSaving">Redeem Voucher
                  <span class="spinner-border loadingSplinner" *ngIf="isVoucherSaving" role="status">
                    <span class="sr-only"></span>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
